import React from "react";
import "../static/dashboard-ipad.css";

const AppointmentSummaryCards = ({ cards }) => {
  return (
    <section className="appointment-summary-grid">
      {cards.map((card) => (
        <article
          className={`appointment-summary-card ${card.kind}`}
          key={card.kind}
        >
          <span>{card.title}</span>
          <strong>{card.value}</strong>
          <small>{card.subtitle}</small>
        </article>
      ))}
    </section>
  );
};

export default AppointmentSummaryCards;